<div [id]="id" class="notification is-danger is-light" [ngClass]="classes">
  <strong><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ title }}</strong>
  <ng-content></ng-content>
</div>
